import React, {useState, useEffect} from 'react';
import {Redirect, NavLink} from 'react-router-dom';
import {useTranslation} from "react-i18next";
import keys from "../store/keys";
import {setKey, session} from "../store/actions";
import {connect} from "react-redux";
import utils from '../utils/utils';
import adService from '../services/ad';
import userReportService from '../services/user-report';
import NumberFormat from 'react-number-format';
import '../css/user-details.css';
import GalleryImage from "./GalleryImage";
import {swalConfirm, swalDeleteForm, swalError} from "../utils/swal";

function UserReportDetails({
                       session,
                       setKey,
                       ...props
                   }) {
    const {t} = useTranslation();
    const [redirectTo, setRedirectTo] = useState(null);
    const [details, setDetails] = useState(null);

    useEffect(() => {
        reload();
    }, []);

    const reload = () => {
        const reportId = props.match.params.reportId;
        if (reportId) {
            setKey(keys.isLoading, true);
            userReportService.getDetailsById(session.token, reportId)
                .then(result => {
                    if (result.error) {
                        swalError(result.error);
                        setKey(keys.isLoading, false);
                        return;
                    }

                    setKey(keys.isLoading, false);
                    setDetails(result.data);
                });
        }
    }

    const handleMakeResolved = e => {
        e.preventDefault();
        const reportId = details._id;
        if (reportId) {
            swalConfirm({callback: async () => {
                await userReportService.changeStatus(session.token, reportId, 2)
                    .then(result => {
                        if (result.error) {
                            swalError(result.error);
                            setKey(keys.isLoading, false);
                            return;
                        }

                        setKey(keys.isLoading, false);
                        reload();
                    });
            }});
        }
    }

    const handleMakePending = e => {
        e.preventDefault();
        const reportId = details._id;
        if (reportId) {
            swalConfirm({callback: async () => {
                await userReportService.changeStatus(session.token, reportId, 1)
                    .then(result => {
                        if (result.error) {
                            swalError(result.error);
                            setKey(keys.isLoading, false);
                            return;
                        }

                        setKey(keys.isLoading, false);
                        reload();
                    });
            }});
        }
    }

    const handleDeleteReport = e => {
        e.preventDefault();
        const reportId = details._id;
        if (reportId) {
            swalDeleteForm(async () => {
                await userReportService.delete(session.token, reportId)
                    .then(result => {
                        if (result.error) {
                            swalError(result.error);
                            setKey(keys.isLoading, false);
                            return;
                        }

                        setKey(keys.isLoading, false);
                        window.location.href = `/user-reports`;
                    });
            });
        }
    }

    return (
        <div className="container user-details">
            {redirectTo && <Redirect push to={redirectTo}/>}
            {
                details &&
                <div className="row mt-20">
                    <div className="col-sm-3 text-center">
                        <div className="row">
                            <div className="col text-left">
                                <img className="profile-image" src={`${details.userId.fileUrl}`}/>
                                <h6>{t("reported_by")}</h6>
                                <h3><a target="_blank" href={`/users/${details.userId._id}`}>{details.userId.name}</a></h3>
                                <table>
                                    <tbody>
                                    <tr>
                                        <td style={{textAlign: 'center'}}><i className="fa fa-phone"></i></td>
                                        <td>{details.userId.phone}</td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign: 'center'}}><i className="fa fa-envelope"></i></td>
                                        <td>{details.userId.email}</td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign: 'center'}}><i className="fa fa-info"></i></td>
                                        <td>{details.userId.bio}</td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign: 'center'}}><i className="fa fa-clock"></i></td>
                                        <td>{t("member_since")} {utils.monthYearFormat(details.userId.joined)}</td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign: 'center'}}><i className="fa fa-map-marker-alt"></i></td>
                                        <td>{details.userId.cityId && details.userId.cityId.title || ""}, {details.userId.country}</td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign: 'center'}}><i className="fa fa-sim-card"></i></td>
                                        <td>{details.userId.ip}</td>
                                    </tr>
                                    {
                                        details.userId.active === true &&
                                        <tr>
                                            <td style={{textAlign: 'center'}}><i className="fa fa-lock-open"></i></td>
                                            <td><span className="badge badge-primary">{t("col_active")}</span></td>
                                        </tr>
                                    }
                                    {
                                        details.userId.active === false &&
                                        <tr>
                                            <td style={{textAlign: 'center'}}><i className="fa fa-lock"></i></td>
                                            <td><span className="badge badge-danger">{t("col_inactive")}</span></td>
                                        </tr>
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-9">
                        <div className="row">
                            <div className="col">
                                <h2>{t("user_report_details")}</h2>
                            </div>
                        </div>

                        <div className="dashed mt-20">
                            <div className="row">
                                <div className="col text-left">
                                    <h5>{t("report_summary")}</h5>
                                </div>
                                <div className="col text-right">
                                    {details.status === 1 && <button className="btn btn-sm btn-outline-primary m-1" onClick={handleMakeResolved}>{t("make_resolved")}</button>}
                                    {details.status === 2 && <button className="btn btn-sm btn-outline-danger m-1" onClick={handleMakePending}>{t("make_pending")}</button>}
                                    <button className="btn btn-sm btn-outline-danger m-1" onClick={handleDeleteReport}>{t("delete_report")}</button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <p><strong>{t("col_status")}:</strong>&nbsp;{details.status === 1 ? <span className="badge badge-danger m-1">{t("status_pending")}</span> : <span className="badge badge-success m-1">{t("status_resolved")}</span> }</p>
                                    <p><strong>{t("col_type")}:</strong>&nbsp;{details.reportTypeId.title}</p>
                                    <p><strong>{t("col_date")}:</strong>&nbsp;{utils.dayMonthYearFormat(details.date)}</p>
                                    {details.dateChangeStatus && <p><strong>{t("status_updated")}</strong>&nbsp;{utils.dayMonthYearFormat(details.dateChangeStatus)}</p>}
                                    <p><strong>{t("col_message_label")}:</strong>&nbsp;{details.message}</p>
                                </div>
                            </div>
                        </div>
                        <div className="dashed mt-20">
                            <div className="row">
                                <div className="col">
                                    <p><span className="h5">{t("col_report_against")}</span>&nbsp;<a target="_blank" href={`/users/${details.againstUserId._id}`}>{t("goto_details")}</a></p>
                                    <h3><a target="_blank" href={`/users/${details.againstUserId._id}`}>{details.againstUserId.name}</a></h3>
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td style={{textAlign: 'center'}}><i className="fa fa-phone"></i></td>
                                            <td>{details.againstUserId.phone}</td>
                                        </tr>
                                        <tr>
                                            <td style={{textAlign: 'center'}}><i className="fa fa-envelope"></i></td>
                                            <td>{details.againstUserId.email}</td>
                                        </tr>
                                        <tr>
                                            <td style={{textAlign: 'center'}}><i className="fa fa-info"></i></td>
                                            <td>{details.againstUserId.bio}</td>
                                        </tr>
                                        <tr>
                                            <td style={{textAlign: 'center'}}><i className="fa fa-clock"></i></td>
                                            <td>{t("member_since")} {utils.monthYearFormat(details.againstUserId.joined)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{textAlign: 'center'}}><i className="fa fa-map-marker-alt"></i></td>
                                            <td>{details.againstUserId.city}, {details.againstUserId.state}, {details.againstUserId.country}</td>
                                        </tr>
                                        {
                                            details.againstUserId.active === true &&
                                            <tr>
                                                <td style={{textAlign: 'center'}}><i className="fa fa-lock-open"></i></td>
                                                <td><span className="badge badge-primary">{t("col_active")}</span></td>
                                            </tr>
                                        }
                                        {
                                            details.againstUserId.active === false &&
                                            <tr>
                                                <td style={{textAlign: 'center'}}><i className="fa fa-lock"></i></td>
                                                <td><span className="badge badge-danger">{t("col_inactive")}</span></td>
                                            </tr>
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

const mapStateToProps = store => ({ session: store.session});
const mapDispatchToProps = dispatch => ({setKey: (key, value) => dispatch(setKey(key, value))});

export default connect(mapStateToProps, mapDispatchToProps)(UserReportDetails);